<template>
  <div class="registration-button">
    <div title="coming soon" v-if="hide!==1" class="defi">
      <div class="sign-up button defi-button">
        <div class="button-content">
          <span>Defi</span>
          <span class="soon">coming soon</span>
        </div>
      </div>
    </div>
    <div v-if="hide!==0" @click="changeRoute('sign-in')" class="sign-in button">Earn</div>
  </div>
</template>

<script>
export default {
  props: {
    hide: {
      type: Number,
      required: false
    }
  },
  computed: {},
  methods: {
    changeRoute(path) {
      window.open(`http://earn.fortchain.net/${path}`, '_blank');
    }
  }
}
</script>
<style lang="scss">
.registration-button {
  @include flex;

  .button {
    @include center-children;
    width: 136px;
    height: 52px;
    border-radius: 30px;
    cursor: pointer;
    transition: all .4s ease;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 1.1px;
    margin-left: 32px;
    background: $base-color;
    border: 1px solid transparent;
    color: black;
    @media only screen and (max-width: 1366px) and (min-width: 1024px) {
      width: 120px;
      height: 42px;
      font-size: 16px;
    }

    &.defi-button {
      color: white;
      background: transparent;
      border: 1px solid white;
    }

    //&:hover {
    //  background: $base-color;
    //  border: 1px solid transparent;
    //  color: black;
    //}
  }

  .defi {
    position: relative;
    width: fit-content;
    cursor: not-allowed;

    .button {
      margin-left: 0;
      cursor: not-allowed;


      .button-content {

        .soon {
          display: block;
          position: absolute;
          text-align: center;
          width: 100%;
          bottom: -18px;
          left: 0;
          font-size: 13px;
          color: #f44335;
        }
      }
    }

  }
}
</style>